export const HTTP_STATUS = {
	SUCCESS: 200,
	CREATED: 201,
	BAD_REQUEST: 400,
	NOT_FOUND: 404,
	INTERNAL_SERVER_ERROR: 500,
	UNAUTHORIZED: 401,
};

export const HTTP_STATUS_SUCCESS_MESSAGE = true;

export const APP_CONSTANTS = {
	LOADING_MESSAGE: 'Loading...'
}